import mime from "mime";

export const openFileDownloadOverlay = (url: string, filename?: string) => {
  const a = document.createElement('a');
  a.href = url;
  a.download = filename ?? url.substr(url.lastIndexOf("/") + 1)
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}

export const fileFromUrl = async (url: string, forceType?: string): Promise<File> => {
  const response = await fetch(url);
  const data = await response.blob();
  let filename = url.split("/").slice(-1)[0]
  if (filename.split(".").pop() == filename) {
    filename = `${filename}.${mime.getExtension(data.type)}`;
  }
  return new File([data], filename);
}

declare global {
  interface File {
    toBase64(): Promise<string>
    toJSON() : string
  }
}

File.prototype.toBase64 = function (this: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(this);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = error => reject(error);
  });
};

File.prototype.toJSON = function (this: File): string {
  return this.name
}


export default {}
